"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconBackToTop', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M13.7071 12.2929L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L2.29289 12.2929C1.90237 12.6834 1.90237 13.3166 2.29289 13.7071 2.68342 14.0976 3.31658 14.0976 3.70711 13.7071L8 9.41421 12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071 14.0976 13.3166 14.0976 12.6834 13.7071 12.2929zM3 2C2.44771 2 2 2.44771 2 3 2 3.55229 2.44771 4 3 4H13C13.5523 4 14 3.55229 14 3 14 2.44772 13.5523 2 13 2L3 2z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M4 3C3.44772 3 3 3.44772 3 4 3 4.55228 3.44772 5 4 5H16C16.5523 5 17 4.55228 17 4 17 3.44772 16.5523 3 16 3H4zM10.7071 9.29289C10.5196 9.10536 10.2652 9 10 9 9.7348 9 9.48045 9.10536 9.29291 9.29289L3.29289 15.2929C2.90237 15.6834 2.90237 16.3166 3.29289 16.7071 3.68342 17.0976 4.31658 17.0976 4.70711 16.7071L10 11.4142 15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071 17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L10.7071 9.29289z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12.7071 11.2929C12.5196 11.1054 12.2653 11 12 11 11.7348 11 11.4805 11.1054 11.2929 11.2929L4.2929 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071 4.68341 20.0976 5.31658 20.0976 5.70711 19.7071L12 13.4142 18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071 20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L12.7071 11.2929zM5 3.99994C4.44771 3.99994 4 4.44765 4 4.99994 4 5.55222 4.44771 5.99994 5 5.99994L19 5.99994C19.5523 5.99994 20 5.55222 20 4.99994 20 4.44765 19.5523 3.99994 19 3.99994L5 3.99994z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M6.5 5C5.67157 5 5 5.67157 5 6.5 5 7.32843 5.67157 8 6.5 8H25.5C26.3284 8 27 7.32843 27 6.5 27 5.67157 26.3284 5 25.5 5H6.5zM17.0316 15.4111C16.4531 14.863 15.5469 14.863 14.9684 15.4111L5.46839 24.4111C4.86699 24.9808 4.84133 25.9302 5.41107 26.5316 5.98082 27.133 6.93022 27.1587 7.53162 26.5889L16 18.5663 24.4684 26.5889C25.0698 27.1587 26.0192 27.133 26.5889 26.5316 27.1587 25.9302 27.133 24.9808 26.5316 24.4111L17.0316 15.4111z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;